import React, { memo } from 'react'
import tw from 'twin.macro'
import { useSelector } from 'react-redux'
import { Button } from 'src/components/shared/Button'
import { getGigsafeConfigSaving } from 'src/selectors/gigsafeConfig'
import { DocumentReviewCard } from './DocumentReviewCard'
import { FeaturesAndTransfersCard } from './FeaturesAndTransfersCard'
import { OnboardingScreensCard } from './OnboardingScreensCard'

interface Props {
  // Without `partner_settings_manage`: every field disabled and no Save button.
  isReadOnly: boolean
}

const CustomerSettingsFormContentComponent = ({ isReadOnly }: Props) => {
  const isSaving = useSelector(getGigsafeConfigSaving)

  return (
    <div css={tw`flex flex-col gap-6`}>
      <OnboardingScreensCard isReadOnly={isReadOnly} />
      <FeaturesAndTransfersCard isReadOnly={isReadOnly} />
      <DocumentReviewCard isReadOnly={isReadOnly} />
      {isReadOnly ? null : (
        <div css={tw`flex justify-end`}>
          <Button type="submit" size="small" color="dark" className={tw`px-4`} loading={isSaving}>
            Save settings
          </Button>
        </div>
      )}
    </div>
  )
}

export const CustomerSettingsFormContent = memo(CustomerSettingsFormContentComponent)
